/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
// @mui
import { List, Collapse } from '@mui/material';
//
import { NavItemRoot, NavItemSub } from './NavItem';
import { getActive } from '..';
import { ListItemIconStyle, ListItemStyle, ListItemTextStyle } from './style';

// ----------------------------------------------------------------------

NavListRoot.propTypes = {
  isCollapse: PropTypes.bool,
  list: PropTypes.object,
};

export function NavListRoot({ list, isCollapse }) {
  const { pathname } = useLocation();

  const active = getActive(list.path, pathname);

  const [open, setOpen] = useState(active);

  const hasChildren = list.children;



  const [userRole, setUserRole] = useState(null);
  const [data, setdata] = useState([]);
  const url = 'https://api.dg.dev-iuh.xyz';
  const token = localStorage.getItem('accessToken');
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user_new'));
    if (storedUser) {
      setUserRole(storedUser?.role);
    }
    fetchdata();
  }, []);
  const fetchdata = () => {
    axios
      .get(`${url}/api/subadmin/permission/website`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.status === true) {
          localStorage.setItem('setitem', JSON.stringify(res?.data?.data));

          setdata(res?.data?.data);
        }
      })
      .catch((err) => {
        console.log(err, 'err');
      });
  };

  if (hasChildren) {
    return (
      <>
        {userRole === 'admin' ? (
          <NavItemRoot item={list} isCollapse={isCollapse} active={active} open={open} onOpen={() => setOpen(!open)} />
        ) : (
          <NavItemRoot item={list} isCollapse={isCollapse} active={active} open={open} onOpen={() => setOpen(!open)} />
          // data?.map((data) => (
          //   <>
          //   {/* <NavItemRoot item={list} isCollapse={isCollapse} active={active} open={open} onOpen={() => setOpen(!open)} /> */}
          //     <ListItemStyle activeRoot={active}>
          //       <ListItemIconStyle>{list?.icon}</ListItemIconStyle>
          //       <Link to={`/dashboard/websitechanges/${data?.id}`} style={{textDecoration:"none"}}>
          //       <ListItemTextStyle disableTypography primary={data?.title} isCollapse={isCollapse} />
          //       </Link>
                
          //     </ListItemStyle>
          //   </>
          // ))
        )}
        {!isCollapse && (
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {(list.children || []).map((item) => (
                <NavListSub key={item.title} list={item} />
              ))}
            </List>
          </Collapse>
        )}
      </>
    );
  }

  return <NavItemRoot item={list} active={active} isCollapse={isCollapse} />;
}

// ----------------------------------------------------------------------

NavListSub.propTypes = {
  list: PropTypes.object,
};

function NavListSub({ list }) {
  const { pathname } = useLocation();

  const active = getActive(list.path, pathname);

  const [open, setOpen] = useState(active);

  const hasChildren = list.children;

  if (hasChildren) {
    return (
      <>
        <NavItemSub item={list} onOpen={() => setOpen(!open)} open={open} active={active} />

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 3 }}>
            {(list.children || []).map((item) => (
              <NavItemSub key={item.title} item={item} active={getActive(item.path, pathname)} />
            ))}
          </List>
        </Collapse>
      </>
    );
  }

  return <NavItemSub item={list} active={active} />;
}
